import { render, staticRenderFns } from "./SurgeryHospital.vue?vue&type=template&id=31dc621a&scoped=true"
import script from "./SurgeryHospital.vue?vue&type=script&lang=js"
export * from "./SurgeryHospital.vue?vue&type=script&lang=js"
import style0 from "./SurgeryHospital.vue?vue&type=style&index=0&id=31dc621a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc621a",
  null
  
)

export default component.exports